var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimalsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58571 10.5077C2.47726 7.09565 9.78531 2.02123 12.548 2.14412C15.5916 2.27967 17.1978 9.37749 15.3079 12.0194C14.1419 13.6492 7.70515 10.9231 1.98247 10.7592",
    stroke: "#209498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68983 5.92958C4.94229 -4.0684 8.85944 2.63125 6.36609 5.02534",
    stroke: "#209498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27695 4.58004C11.579 2.29091 11.3885 7.30641 6.64826 7.6716",
    stroke: "#209498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25185 8.82009C4.24271 8.77048 4.23365 8.72089 4.22428 8.67134",
    stroke: "#209498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2407 12.231C15.7948 11.7331 16.4551 11.258 17.1372 11.0536C20.3341 10.0959 20.1737 15.1169 18.0872 16.7536C16.0228 18.3732 10.9155 14.9394 10.206 18.4201",
    stroke: "#209498",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalsHover);
export default __webpack_public_path__ + "static/media/animalsHover.9cacb676c4c24c1d8c6ebfe64dbe45fb.svg";
export { ForwardRef as ReactComponent };